

























import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconUpload } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIcon,
    BIconUpload,
    NextPrevBtn,
    Footer,
  },
})
export default class ArtPerfCorp extends Vue {
  protected nxtprevArtPerfCorp = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail1.png",
    NextImage: "/thumbnail3.png",
    PrevLink: "/PerformanceArtistique/ExemplesEtudiants",
    NextLink: "/PerformanceArtistique/Bibliographie",
  };
}
